import React, {ButtonHTMLAttributes, FC} from 'react';
import classes from "./HLButton.module.scss";
import cn from 'classnames';

export enum HLButtonStyleType {
  ORANGE = 'ORANGE',
  GRAY = 'GRAY',
}

interface HLButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  styleType?: HLButtonStyleType;
  icon?: React.ReactNode;
}

const HLButton: FC<HLButtonProps> = ({
                                       children,
                                       styleType = HLButtonStyleType.ORANGE,
                                       icon,
                                       ...props
                                     }) => {
  const classNames = cn(classes.button, {
    [classes.grayButton]: styleType === HLButtonStyleType.GRAY,
    [classes.orangeButton]: styleType === HLButtonStyleType.ORANGE,
  });

  return (
      <button
          {...props}
          className={classNames}
      >
        {icon && <span className={classes.iconWrapper}>{icon}</span>}
        <span className={classes.text}> {children}</span>
      </button>
  );
};

export default HLButton;